import React, { useState, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import '../../../assets/css/customer/customertestimonials/customertestimonials.css';

const ratingLabels = ['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent!'];
const CustomerTestimonials = ({ onClose, bookingId }) => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [formData, setFormData] = useState({
    rating: 0,
    review_message: '',
    image: null,
  });

  const [hoverRating, setHoverRating] = useState(0);
  const [fileName, setFileName] = useState('Choose an image');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
   const name = file.name;
    setFileName(name.length > 30 ? name.substring(0, 27) + '...' : name);
      setFormData((prev) => ({ ...prev, image: file }));
    }
  };

  const handleRating = (n) => {
    setFormData((prev) => ({ ...prev, rating: n }));
  };

  const handleSubmit = () => {
    const { review_message, rating } = formData;

    if (!review_message || rating === 0) {
      setError('Please fill in all required fields');
      setTimeout(() => setError(''), 2000);
      return;
    }

    const data = new FormData();
    data.append('jjbooking_id', bookingId);
    data.append('rating', rating);
    data.append('review_message', review_message);
    if (formData.image) {
      data.append('image', formData.image);
    }

    setLoading(true);

    axios
      .post(`${baseUrl}/customer/add-customer-review`, data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.data.success) {
          setSubmitted(true);
        } else {
          setError('Something went wrong. Please try again.');
          setTimeout(() => setError(''), 2000);
        }
      })
      .catch((err) => {
        const msg = err.response?.data?.message;
        if (msg === 'Review already submitted. Use update instead.') {
           setError('Review already submitted.');

        } else {
          setError('Failed to submit review. Please try again.');
        }
        setTimeout(() => setError(''), 3000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const activeRating = hoverRating || formData.rating;

  return (
    <div className="rf-wrap">
      <div className="rf-header">
        <div className="rf-badge">
          <span className="rf-badge-stars">★★★★★</span>
          <span>customer review</span>
        </div>
        <h2>Submit Your Review</h2>
        <p>Your feedback helps us serve you better</p>
      </div>

      {!submitted ? (
        <div className="rf-body">
          <div className="rf-field">
            <label>
              <span className="rf-dot"></span>Your Rating
            </label>
            <div className="rf-stars">
              {[1, 2, 3, 4, 5].map((n) => (
                <span
                  key={n}
                  className={n <= activeRating ? 'active' : ''}
                  onClick={() => handleRating(n)}
                  onMouseEnter={() => setHoverRating(n)}
                  onMouseLeave={() => setHoverRating(0)}
                >
                  ★
                </span>
              ))}
            </div>
            <div className="rf-rating-label">
              {activeRating ? ratingLabels[activeRating] : 'Select a star rating'}
            </div>
          </div>

          <div className="rf-field">
            <label>Review Message</label>
            <textarea
              name="review_message"
              placeholder="Share your experience..."
              value={formData.review_message}
              onChange={handleChange}
            />
          </div>

          <div className="rf-field">
            <label>Upload Photo (optional)</label>
            <div className="rf-upload" onClick={() => document.getElementById('rf-file-input').click()}>
              <div className="rf-upload-icon">↑</div>
              <strong>{fileName}</strong>
              <p>PNG, JPG — max 5MB</p>
            </div>
            <input
              type="file"
              id="rf-file-input"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>

          <button
            className={`rf-submit${error ? ' rf-submit--error' : ''}`}
            onClick={handleSubmit}
            disabled={loading}
          >
            {error ? error : loading ? 'Submitting...' : 'Submit Review →'}
          </button>
        </div>
      ) : (
        <div className="rf-success">
          <div className="rf-success-icon">✓</div>
          <h3>Thank you!</h3>
          <p>Your review has been submitted successfully.</p>
          {onClose && (
            <button className="rf-close-btn" onClick={onClose}>
              Close
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerTestimonials;